import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getVariables = {
  name: "getVariables" as const,
  input: z.object({ schemaType: createEnum(SchemaType).optional() }),
  output: z.object({
    variables: z.array(
      z.object({
        id: z.string(),
        label: z.string(),
        dynamic: z.boolean(),
        inputSchema: z.record(z.string(), z.unknown()),
      }),
    ),
  }),
};
